"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../st");
var interface_1 = require("./interface");
var should_log_1 = require("./should-log");
if (!st_1.st.info) {
    st_1.st.info = st_1.st.log = st_1.st.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV != "production" && should_log_1.shouldLog(interface_1.LogLevel.INFO)) {
            console.info.apply(console, __spreadArrays(["ℹ️"], args));
        }
    };
    st_1.st.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV != "production" && should_log_1.shouldLog(interface_1.LogLevel.WARN)) {
            console.warn.apply(console, __spreadArrays(["🔥"], args));
        }
    };
    st_1.st.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV != "production" && should_log_1.shouldLog(interface_1.LogLevel.ERROR)) {
            console.error.apply(console, __spreadArrays(["💣"], args));
        }
    };
}
else {
    if (process.env.NODE_ENV === 'development') {
        st_1.st.warn('Module log is loaded twice. Check for duplicate famework import!');
    }
}
//# sourceMappingURL=log.js.map